<template>
  <el-container>
    <el-main class="CalendarLayout" style="background-color: #fff;">
      <div v-if="myInterview.length > 0" class="myAppointment"  v-for="(item, itemIndex) in myInterview" :key="itemIndex">
        <el-form>
          <p>会议号：{{item.TencentNo}}</p>
          <div class="AppointmentDate">
            <div>访谈日期：<b>{{item.InterviewDate}}</b></div>
            <span v-if="item.Status==1">待访谈</span>
            <span v-if="item.Status==2" style="color:#ccc">已取消</span>
            <span v-if="item.Status==3" style="color:#ccc">已完成</span>
            <span v-if="item.Status==4">候选预约中</span>
          </div>
          <div class="AppointmentStatus" v-if="item.Status==1">未开始</div>
          <div class="AppointmentStatus" v-if="item.Status==2"> </div>
          <div class="AppointmentStatus" v-if="item.Status==3"> </div>
          <div class="AppointmentStatus blackFont" v-if="item.Status==4">您当前候选补在第<span class="red">{{item.CurrentRank}}</span>位</div>
          <div class="AppointmentTime"><b>{{item.InterviewTimeBegin}}</b><span>--</span><span class="time">{{item.Duration}}分钟</span><span>--</span><b>{{item.InterviewTimeEnd}}</b></div>
          <div class="buttonBlock">
            <el-button type="primary" @click="enterInterview(item.TencentLink)" v-if="item.Status==1">进入访谈</el-button>
            <el-button @click="cancelInterview(item)" v-if="item.Status==1">取消访谈</el-button>
            <el-button @click="cancelInterview(item)" v-if="item.Status==4">取消候补</el-button>
          </div>
        </el-form>
      </div>

      <div v-if="myInterview.length == 0" class="noAppointment" >
        <div>您没有预约访谈记录</div>
      </div>
<!--      <div class="myAppointment">-->
<!--        <el-form>-->
<!--          <div class="AppointmentDate"><div>访谈日期：<b>2023-05-29</b></div><span>待访谈</span></div>-->
<!--          <div class="AppointmentStatus">未开始</div>-->
<!--          <div class="AppointmentTime"><b>15:00</b><span>&#45;&#45;</span><span class="time">20分钟</span><span>&#45;&#45;</span><b>15:20</b></div>-->
<!--          <div class="buttonBlock">-->
<!--            <el-button type="primary" @click="SaveChanges()">进入访谈</el-button>-->
<!--            <el-button @click="drawer = false">取消访谈</el-button>-->
<!--          </div>-->
<!--        </el-form>-->
<!--      </div>-->
<!--      <div class="myAppointment">-->
<!--        <el-form>-->
<!--          <div class="AppointmentDate"><div>访谈日期：<b>2023-05-29</b></div><span>待访谈</span></div>-->
<!--          <div class="AppointmentStatus">未开始</div>-->
<!--          <div class="AppointmentTime"><b>15:00</b><span>&#45;&#45;</span><span class="time">20分钟</span><span>&#45;&#45;</span><b>15:20</b></div>-->
<!--          <div class="buttonBlock">-->
<!--            <el-button type="primary" @click="SaveChanges()">进入访谈</el-button>-->
<!--            <el-button @click="drawer = false">取消访谈</el-button>-->
<!--          </div>-->
<!--        </el-form>-->
<!--      </div>-->
    </el-main>
  </el-container>
</template>

<script>
export default {
  mounted() {
    this.loadMyInterview(this.Global.userID);
  },
  data() {
    return {
      myInterview:[],
      cancelData:{
        AppointDate: '',	//预约日期
        InterviewDate: '',	//访谈日期
        InterviewTimeBegin: '',	//访谈开始时间
        KeyNo: 0,		//会议室id  （取消候选，不需此字段）
        ScheduleNo: 0,	//排班id  （取消候选，不需此字段）
        UserID: '',	//学员id
        Type:1   // 取消访谈预约类型   1-取消访谈  2-取消候选排队
      },
    };
  },
  props: {
    showToday: {
      type: Boolean,
      default: true, //是否显示返回今天按钮
    },
  },
  methods: {
    loadMyInterview(UserID) {
      //列表
      this.$Http_Post('HomePage/QueryInterviewList', {
        UserID:UserID,
      }).then((res) => {
        if (res.Code == 0) {
          console.warn(res.Data.List);
          this.myInterview = res.Data.List;
          console.warn(this.myInterview.length)
        }
      });
    },
    cancelInterview(item) {
      //处理传入的参数
      // console.warn("11111")
      // debugger;
      this.$Http_Post('HomePage/CancelInterview', {
        AppointDate: item.AppointDate,	//预约日期
        InterviewDate: item.InterviewDate,	//访谈日期
        InterviewTimeBegin: item.InterviewTimeBegin,	//访谈开始时间
        KeyNo: item.KeyNo,		//会议室id  （取消候选，不需此字段）
        ScheduleNo: item.ScheduleNo,	//排班id  （取消候选，不需此字段）
        UserID: this.Global.userID,	//学员id
        Type:item.Status=="1"?1:2,   // 取消访谈预约类型   1-取消访谈  2-取消候选排队
      }).then((res) => {
        if (res.Code == 0) {
          // console.warn(this.Global.SourceNo+"111");
          if(item.Status=="1"){
            this.Global.request_successful("取消访谈成功");
          }else if(item.Status=="4"){
            this.Global.request_successful("取消候补成功");
          }
          setTimeout(function() {
            location.reload();// 需要执行的代码
          }, 500);
          // console.warn(this.Global.SourceNo);
        }else{
          this.Global.request_failure(res.Message);
        }
      });
    },
    enterInterview (link) {
      // window.location.href = link;
      window.open(link, '_blank')
    },
  },
}
</script>
<style>
.CalendarLayout .myAppointment {
  border: 1px solid rgba(222, 222, 222, 1);
  border-radius: 4px;
  font-size: 17px;
  color: #666;
  width: 360px;
  padding:15px 30px 30px;
  float: left;
  margin-left: 20px;
  margin-top: 20px;
}
.CalendarLayout .noAppointment {
  border: 1px solid rgba(222, 222, 222, 1);
  border-radius: 4px;
  font-size: 17px;
  color: #666;
  text-align: center;
  width: 100%;
  padding: 30px;
  float: left;
  margin-left: 20px;
  margin-top: 20px;
}
.CalendarLayout .AppointmentDate {
  display: flex;
  justify-content:space-between;
}

.CalendarLayout .AppointmentDate span {
  font-size: 14px;
  color: #0d78e3;
}
.CalendarLayout .AppointmentStatus {
  font-size: 14px;
  color:rgba(238, 10, 36, 1);
  text-align: center;
  padding-top: 25px;
  height: 20px;
}
.CalendarLayout .blackFont {
  color:#333;
}
.CalendarLayout .red {
  color:rgba(238, 10, 36, 1);
  font-weight: bold;
}
.CalendarLayout .AppointmentTime {
  font-size: 26px;
  color: #ccc;
  display: flex;
  justify-content:space-around;
  padding-left: 40px;
  padding-right: 40px;
}
.CalendarLayout .AppointmentTime b {
  font-size: 26px;
  color: #333;
}
.CalendarLayout .AppointmentTime .time {
  font-size: 14px;
  color: #999;
  padding:6px;
  background-color: #eee;
}
.CalendarLayout .buttonBlock {
  padding-top: 30px;
  padding-left: 70px;
  height: 30px;
}
</style>
